import React from "react";
import Footer from "./component/Footer";

function WhitePartner() {
  return (
    <div className="Pricing">
      <main className="font-nunito">
        {/* Jumbotron Section Start Here */}
        <section className="pt-16">
          <div id="jumbotron">
            <img className="w-full" src="./img/pricing.webp" alt="" />
          </div>
        </section>
        {/* Jumbotron Section End Here */}
        <section className="pb-24 bg-main-color">
          <h2 className="text-white text-xl pt-11 lg:pt-11 mb-9 font-bold text-center font-nunito">
            SUBSCRIBE ON NEWS
          </h2>
          <div className="m-auto">
            <form class="flex justify-center px-6">
              <input
                class="px-4 w-full lg:w-1/4 font-poppins  border-white mr-0  border-2 text-white  bg-main-color placeholder-white"
                placeholder="your@mail.com"
                for="email"
              />
              <button class="px-8 font-poppins bg-white  text-main-color p-4   border-t border-b border-r">
                Subscribe
              </button>
            </form>
            <p className="font-poppins text-sm text-white text-center mt-5">
              Stay Up to date with the latest news
            </p>
          </div>
        </section>
        {/* SUBSCRIPTION END HERE */}

        {/*OUR PARTNERS START HERE */}
        <section className="pb-28 px-6">
          <h2 className="text-heading-color text-4xl pt-11 mb-16 font-bold text-center">
            OUR PARTNERS
          </h2>

          <ul className="flex justify-center items-center">
            <li className="mx-2 lg:mx-7">
              <img src="./img/bni.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/tsm.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/abb.png" alt="" />
            </li>
          </ul>

          <ul className="flex justify-center items-center mt-24">
            <li className="mx-2 lg:mx-7">
              <img src="./img/danone.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/pwc.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/dep-pertanian.png" alt="" />
            </li>
          </ul>
        </section>

        {/* Follow Us */}
        <section>
          <h3 className="text-center text-main-color font-bold">
            FOLLOW US IN SOCIAL NETWORKS
          </h3>
          <div>
            <ul className="flex justify-center mt-6">
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">FACEBOOK</a>
              </li>
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">INSTAGRAM</a>
              </li>
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">LINKEDIN</a>
              </li>
            </ul>
          </div>
        </section>

        {/* Form */}
        <section className="pb-28 mt-10">
          <h2 className="text-heading-color text-4xl pt-11 mb-5 font-bold text-center">
            JOIN WITH US
          </h2>
          <form class="bg-white rounded px-6 lg:px-8 pt-6 pb-8 mb-4 lg:mx-44 font-poppins">
            <div class="mb-4">
              <label class="block text-gray-700 text-md  mb-2" for="username">
                Company<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="company_name"
                type="text"
                placeholder="Your company name"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="email">
                Email Address<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                placeholder="Your@mail.com"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="phone">
                Mobile Phone<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline"
                id="tel"
                type="tel"
                placeholder="Enter your phone number"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="phone">
                Message
              </label>
              <textarea
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline"
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
              ></textarea>
            </div>

            <div class="flex items-center justify-center">
              <button
                class="bg-main-color hover:bg-orange-dark text-white py-2 px-12 rounded focus:outline-none focus:shadow-outline"
                type="button"
              >
                Submit
              </button>
            </div>
          </form>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default WhitePartner;
